import React from "react";

import LottieAnimationWrapper from "./LottieAnimationWrapper";

import successAnimation from "assets/lottie/success.json";

const SuccessCheck = ({ height = 250 }) => {
  return (
    <LottieAnimationWrapper
      lottieFile={successAnimation}
      height={height}
      loop={false}
    />
  );
};

export default SuccessCheck;
